import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { FormSetupState } from '../types';
import { initialState } from './formSetupState';

export const formSetupSlice = createSlice({
  name: 'formSetup',
  initialState,
  reducers: {
    setWorkOrder: (
      state,
      action: PayloadAction<FormSetupState['workOrder']>,
    ) => {
      state.workOrder = action.payload;
    },
    setJobSite: (state, action: PayloadAction<FormSetupState['jobSite']>) => {
      state.jobSite = action.payload;
    },
  },
});

export const { actions: formSetupActions } = formSetupSlice;

const selectFormSetup = (state: RootState) => state.formSetup;

export const selectWorkOrder = createSelector(
  [selectFormSetup],
  formSetup => formSetup.workOrder,
);

export const selectJobSite = createSelector(
  [selectFormSetup],
  formSetup => formSetup.jobSite,
);

export default formSetupSlice.reducer;
